import React, { useEffect, useState } from "react";
import { getNews } from "../Service/Api";
import { Link } from "react-router-dom";
const News = () => {
    
    const [data,setData] = useState([]);
    const [loading,setLoading] = useState(true);
    const [error,setError] = useState(null); 
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    useEffect(() =>{
          const fetchData = async () => {
             try {
                const response = await getNews();
                 setData(response);
             }catch(error){
                setError(error)
             }finally {
                 setLoading(false);
             } 
          };
          fetchData();
    },[]);
 

    const empty = [
        {id:1,title:"Stay Tunned For More Updates"}  
      ]
    return (
        <>
        <marquee onMouseOver={(event) => event.currentTarget.stop()} direction="up"  onMouseOut={(event) => event.currentTarget.start()}>
          
         
            {data && data.length > 0 ? (
                data.map((item) => {
                    const eventdate = new Date(item.fromDate);
                    const day = eventdate.getDate();
                    const month = monthNames[eventdate.getMonth()]; 
                  return (
                    <div className='newsarea' key={item.id}>
                        <div>
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/newsli.gif" />
                            <div>
                            <p><b> {item.title}</b></p>
                            <p className='newshead'>{item.description} </p>
                            <p className="newsdate"> {day} {month}</p>
                            </div>
                        </div> 
                        <Link to={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/api/image/${item.attachments}`} target='_blank'>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/attachment.png" />
                        </Link> 
                </div>   
                )}) 
              ) : (
                 empty.map((item) =>(
                   <div className='newsarea' key={item.id}>
                        <div>
                        <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/newsli.gif" />
                            <div>
                            <p><b> {item.title}</b></p>
                            <p className='newshead'>{item.description} </p>
                            <p className="newsdate">DD MM</p>
                            </div>
                        </div> 
                        <Link to="#" target='_blank'>
                            <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMATD/public/Images/attachment.png" />
                        </Link> 
                </div>   
                ))  
                 )}  
 
              
            </marquee>
        </>
    );
};

export default News;
